import axiosInstance from "@/axiosInstance";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Fetch Wishlist Products
export const fetchWishListProducts = createAsyncThunk(
  "wishlist/fetchWishListProducts",
  async (_, { rejectWithValue }) => { // No need to pass token here
    try {
      const response = await axiosInstance.get("/api/website/wishlist");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Add to wishlist  
export const addWishListProducts = createAsyncThunk(
  "wishlist/addWishListProducts",
  async ({payload}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/api/website/wishlist/add", payload);
      return response.data;
    } catch (error) {
      console.error("Error adding to wishlist:", error); // Log the error
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);


// Remove from wishlist
export const removeWishListProduct = createAsyncThunk(
  "wishlist/removeWishListProduct",
  async ({id}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete("/api/website/wishlist", {
        data: { wishlist_id: id },
      });
      return { wishlist_id: id };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);


const wishListSlice = createSlice({
  name: "wishlist",
  initialState: {
    products: [],
    deletedProducts: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addWishListProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addWishListProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload; // Add product with wishlist_id
      })
      .addCase(addWishListProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(removeWishListProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeWishListProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.deletedProducts = action.payload; 
      })
      
      .addCase(removeWishListProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchWishListProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWishListProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(fetchWishListProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default wishListSlice.reducer;
